import { path } from 'ramda';
import jwtDecode from 'jwt-decode';

export const getAccessToken = state => state.session.accessToken;

export const selectUserId = (state) => {
  const accessToken = path(['session', 'accessToken'], state);

  if (!accessToken) return undefined;

  try {
    const decodedToken = jwtDecode(accessToken);
    return decodedToken.user_id;
  } catch (exc) {
    console.error('app:components:ApiUser:Form error decoding token: ' + exc.message);
    return undefined;
  }
};
